<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Relatório atendimentos"
            description="Atendimentos, procedimentos, vacinas ou visitas realizados nas últimos 90 dias"
            url="/atendimentos-no-mes/equipe"
            v-if="id_funcao == 1 || id_funcao == 7 || id_funcao == 2"
          />
          <SectionTitle
            title="Relatório atendimentos"
            description="Atendimentos, procedimentos, vacinas ou visitas realizados nas últimos 90 dias"
            url="/atendimentos-no-mes/profissional"
            v-if="id_funcao == 4 || id_funcao == 6"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4 col-12">
          <label for="datepicker-full-width">Data inicio</label>
          <input class="form-control" v-model="data_inicio" type="date" />
        </div>
        <div class="col-md-4 col-12">
          <label for="datepicker-full-width">Data fim</label>
          <input class="form-control" v-model="data_fim" type="date" />
        </div>
        <div class="row col-md-4 col-12 c-row">
          <button type="button" class="btn" @click="filterDate()">
            Filtrar
          </button>
          <button type="button" class="btn" @click="clear()">Limpar</button>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-lg-4 mb-3">
          <select
            name=""
            id=""
            v-model="periodo"
            class="form-control"
            @change="onChangePeriodo($event)"
          >
            <option value="" selected disabled>Período</option>
            <option value="30-dias">
              Últimos 30 dias
            </option>
            <option value="mes-atual">Mês Atual</option>
          </select>
        </div> -->
        <div class="col-md-12">
          <div class="info-table">
            <div class="info-table-item">
              <h4 class="name-professional">
                <i class="icofont-user"></i> {{ nomeProfissional }}
              </h4>
            </div>
            <div class="info-table-item">
              <p class="fonte">
                <b>Fonte:</b> e-SUS PEC, {{ ultimaAtualizacao }}
              </p>
            </div>
            <div class="info-table-item">
              <b>{{ total_de_visitas_realizadas }}</b> atendimentos realizados
            </div>
            <div
              v-if="
                $store.state.id_funcao == 1 ||
                $store.state.id_funcao == 2 ||
                $store.state.id_funcao == 7 ||
                $store.state.id_funcao == 4
              "
              class="info-table-item"
            >
              <button class="btn-pdf" v-on:click="generatePdf()">
                <i class="icofont-print"></i> PDF
              </button>
            </div>
          </div>
          <table class="table table-responsive table-striped" id="table">
            <thead class="thead-light">
              <tr>
                <th>Data</th>
                <th>Manhã</th>
                <th>Tarde</th>
                <th>Noite</th>
              </tr>
            </thead>
            <loader-table-skeleton
              :cols="4"
              :rows="10"
              :active="loading"
            ></loader-table-skeleton>
            <tbody v-if="loading == false">
              <tr
                v-for="(item, index) in displayedAtendimentos"
                v-bind:key="index"
              >
                <td>{{ formatDate(item.dt_atendimento) }}</td>
                <td>{{ item.manha !== null ? item.manha : '' }}</td>
                <td>{{ item.tarde !== null ? item.tarde : '' }}</td>
                <td>{{ item.noite !== null ? item.noite : '' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-12">
          <pagination
            :page="page"
            :pages="pages"
            v-on:update:page="page = $event"
          >
          </pagination>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '../../components/Menu'
import Footer from '../../components/Footer'
import SectionTitle from './SectionTitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import LoaderTableSkeleton from '../../components/LoaderTableSkeleton.vue'
import * as Functions from './functions.js'
import Pagination from '@/components/utils/Pagination'
import utils from '@/mixins/utils.js'
import ModalInfo from './ModalInfo'

export default {
  name: 'AtendimentosNoMesDetalhar',
  components: {
    Menu,
    Footer,
    PulseLoader,
    SectionTitle,
    LoaderTableSkeleton,
    Pagination,
    ModalInfo,
  },
  mixins: [utils],
  computed: {
    displayedAtendimentos() {
      this.setPages(this.atendimentos)
      return this.paginate(this.atendimentos)
    },
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
  },
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipes: '',
      equipe: '',
      atendimentos: [],
      atendimentosOriginais: [],
      page: 1,
      perPage: 10,
      pages: [],
      nomeProfissional: '',
      periodo: '',
      total_de_visitas_realizadas: 0,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      data_inicio: '',
      data_fim: '',
    }
  },
  methods: {
    formatarData(data) {
      let dia = String(data.getDate()).padStart(2, '0')
      let mes = String(data.getMonth() + 1).padStart(2, '0') // Os meses são indexados a partir de 0, por isso é adicionado +1
      let ano = data.getFullYear()

      return dia + '/' + mes + '/' + ano
    },

    filterDate() {
      try {
        // Obtenha as datas iniciais e finais selecionadas pelo usuário
        const dataInicial = new Date(this.data_inicio)
        const dataFinal = new Date(this.data_fim)

        const dataAtual = new Date()
        const data90diasAtras = new Date(
          dataAtual.getFullYear(),
          dataAtual.getMonth(),
          dataAtual.getDate() - 90
        )

        const data90diasAtrasFormatada = this.formatarData(data90diasAtras)
        if (dataInicial < data90diasAtras) {
          this.$toast.error(
            'Erro.',
            `A data inicial não pode ser inferior a ${data90diasAtrasFormatada}.`,
            {
              position: 'topRight',
            }
          )
          return false
        }

        // Filtrar a lista de cadastros com base nas datas selecionadas
        this.atendimentos = this.atendimentosOriginais.filter((cadastro) => {
          const dtAtendimento = new Date(cadastro.dt_atendimento)

          // Verificar se a data do cadastro está entre as datas selecionadas
          return dtAtendimento >= dataInicial && dtAtendimento <= dataFinal
        })

        this.totalVisitas(this.atendimentos)
      } catch (error) {
        this.$toast.error('Data inválida!', 'Error:', {
          position: 'topRight',
        })
      }
    },
    clear() {
      this.data_inicio = ''
      this.data_fim = ''
      this.atendimentos = this.atendimentosOriginais
      this.totalVisitas(this.atendimentos)
    },
    setPages(atendimentos) {
      let numberOfPages = Math.ceil(atendimentos.length / this.perPage)
      this.pages = []
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index)
      }
    },

    paginate(atendimentos) {
      let page = this.page
      let perPage = this.perPage
      let from = page * perPage - perPage
      let to = page * perPage
      return atendimentos.slice(from, to)
    },

    async onChangePeriodo(event) {
      let periodo = event.target.value
      this.loading = true
      try {
        this.loading = true
        let atendimentos = await this.$api.get(
          '/app/atendimentos-no-mes/profissional/periodo/' +
            this.$route.params.nu_cns +
            '/' +
            this.cod_ibge +
            '/' +
            periodo
        )
        if (atendimentos) {
          this.atendimentos = []
          this.atendimentos = atendimentos.data
          this.total_de_visitas_realizadas = atendimentos.data.reduce(function (
            acc,
            obj
          ) {
            return acc + parseInt(obj.qtd_atendimentos)
          },
          0)
          this.loading = false
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },

    buscarProfissional() {
      this.$api
        .post('/app/profissional/cpf', {
          co_ibge: this.cod_ibge,
          cpf: this.$route.params.nu_cpf,
        })
        .then((response) => {
          this.nomeProfissional = response.data.no_profissional
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    async carregarDadosIniciais() {
      try {
        this.loading = true

        let url = ''
        const cbo = this.$route.params.co_cbo.slice(0, 4)
        if (cbo == '2232') {
          url = `/app/atendimentos-no-mes/odontologo`
        } else if (cbo == '5151') {
          url = `/app/atendimentos-no-mes/acs`
        } else if (cbo == '3222') {
          url = `/app/atendimentos-no-mes/tec-enfermagem`
        }
        // (cbo != '2232' || cbo != '5151' || cbo != '3222')
        else {
          url = `/app/atendimentos-no-mes/outros`
        }

        let atendimentos = await this.$api.post(url, {
          co_ibge: this.cod_ibge,
          cpf: this.$route.params.nu_cpf,
        })
        if (atendimentos) {
          this.atendimentos = atendimentos.data
          this.atendimentosOriginais = atendimentos.data
          this.totalVisitas(this.atendimentosOriginais)
          this.loading = false
        }
      } catch (error) {
        console.log(error)
        this.loading = false
        this.$toast.error(
          'Problema ao carregar os dados! Recarregue a página! Se o problema persistir entre em contato com o Administrador Municipal do e-SUS PEC',
          'Error:',
          {
            position: 'topRight',
          }
        )
      }
    },
    totalVisitas(totalVisitas) {
      this.total_de_visitas_realizadas = totalVisitas.reduce(function (
        acc,
        obj
      ) {
        let manha = Number(obj.manha) || 0
        let tarde = Number(obj.tarde) || 0
        let noite = Number(obj.noite) || 0
        return acc + manha + tarde + noite
      },
      0)
    },
    generatePdf() {
      Functions.generatePdf(
        this.atendimentos,
        this.nomeProfissional,
        this.total_de_visitas_realizadas,
        this.data_inicio,
        this.data_fim
      )
    },

    validateToken() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.carregarDadosIniciais()
      this.buscarProfissional()
    },
  },
  created() {
    this.validateToken()
  },
}
</script>

<style>
.name-professional {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 700;
}
@media (max-width: 768px) {
  .name-professional {
    font-size: 17px;
    text-align: center;
  }
}
</style>
<style scoped>
.c-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.btn {
  margin-top: 30px;
  color: white;
}
</style>
